const Tabs = ({ tabs, activeTab, onTabChange }) => {
  return (
    <div className="overflow-x-auto px-3 pb-2 pt-3 [scrollbar-width:none] sm:px-4 sm:pt-4">
      <div className="flex min-w-max gap-1 rounded-2xl border border-ledger-border bg-card-bg/90 p-1 shadow-sm backdrop-blur sm:min-w-0">
        {tabs.map((tab) => (
          <button
            key={tab}
            className={`min-w-[148px] rounded-xl px-4 py-2.5 text-sm font-semibold transition-all duration-300 sm:min-w-0 sm:flex-1 ${
              activeTab === tab
                ? "bg-brand text-white shadow-md shadow-brand/20"
                : "text-text-sec hover:text-text-pri hover:bg-surface-hover"
            }`}
            onClick={() => onTabChange(tab)}
          >
            {tab}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Tabs;
